import { render, staticRenderFns } from "./act-edit.vue?vue&type=template&id=84dc9816"
import script from "./act-edit.vue?vue&type=script&lang=js"
export * from "./act-edit.vue?vue&type=script&lang=js"
import style0 from "./act-edit.vue?vue&type=style&index=0&id=84dc9816&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84dc9816')) {
      api.createRecord('84dc9816', component.options)
    } else {
      api.reload('84dc9816', component.options)
    }
    module.hot.accept("./act-edit.vue?vue&type=template&id=84dc9816", function () {
      api.rerender('84dc9816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/act-edit.vue"
export default component.exports